"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var hash = {};
var cache = [];

var add = function add(url) {
    if (!hash[url]) {
        hash[url] = new Image();
        hash[url].src = url;

        cache.push(hash[url]);
    }
    return hash[url];
};

var get = function get(url) {
    return add(url);
};

var stuff = function stuff(urls) {
    if (urls.length > 0) {
        urls.map(add);
    }
};

var ImageCache = {
    add: add,
    stuff: stuff,
    get: get,
    hash: hash,
    cache: cache
};

exports["default"] = ImageCache;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-preload/lib/ImageCache.js
 ** module id = 523
 ** module chunks = 0
 **/